import React from 'react'
import { LoaderIcon } from '../../utils/svgIcons'

function Loading() {
    return (
        <div className="loader w-full overflow-hidden">
            <div className="relative transform scale-[1.8]">
                <LoaderIcon className="animate-bounce transition-all duration-300 " />
                <div className="absolute inset-0 bg-blue-500 rounded-full blur-xl opacity-20 animate-pulse"></div>
            </div>
        </div >
    )
}

export default Loading
